"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMatchedEventId = exports.isEventTargetTagNameLink = void 0;

/**
 * @name isEventTargetTagNameLink
 * @description check if event target tagName is a link
 * @returns {boolean}
 */
var isEventTargetTagNameLink = function isEventTargetTagNameLink(event) {
  var _event$target;

  return ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.tagName) === 'A';
};
/**
 * @name isMatchedEventId
 * @description compares event target id
 * @param {MouseEvent<HTMLDivElement>} event - Clicked element
 * @param {string} id - id
 * @returns {boolean}
 */


exports.isEventTargetTagNameLink = isEventTargetTagNameLink;

var isMatchedEventId = function isMatchedEventId(event, id) {
  return event.target.id === id;
};

exports.isMatchedEventId = isMatchedEventId;